import React from "react";

export default {
    ui: {
        initialpage: '',
        responsive: { isDesktopOrLaptop: null, isBigScreen: null, isTabletOrMobile: null, isPortrait: null, isRetina: null }
    },
    iam: {
        profile: {
            status: 'LOGGED_OUT',
            username: '',
            fname: '',
            lname: '',
            email: '',
            company: '',
            customer: '',
            contact_number: '',
            manager_name: '',
            manager_email: '',
            accesslvl: '',
            accounttype: '',
            access: '',
            approved: '',
            islocked: '',
            twofactor: '',
            last_logged_in: '',
            registration_date: '',
            approval__date: '',
            force_password_reset: '',
        },
        use_2fa: false,
    },
    app: {
        readOnly: false,
        migrationEnabled: false,
        newAppUrl: '',
        supportEmail: '',
        migrationStatus: 'IDLE',
    }
}
